import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.less';

const ExternalLink = ({
  href,
  title = '',
  ariaLabel = '',
  target = '_blank',
  rel = 'noopener noreferrer',
  classProps = '',
  children,
  dataHelpId,
}) => {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      title={title}
      target={target}
      rel={rel}
      className={classNames(styles.externalLink, classProps)}
      data-help-id={dataHelpId}
    >
      {children}
    </a>
  );
};

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  showIcon: PropTypes.bool,
  classProps: PropTypes.string,
  children: PropTypes.node.isRequired,
  dataHelpId: PropTypes.string,
};

export default ExternalLink;
